import { defaultConfig } from '@formkit/vue'
import { createMultiStepPlugin } from '@formkit/addons'
import { de } from '@formkit/i18n'
import { trash } from '@formkit/icons'
import {
  autocomplete,
  createProPlugin,
  repeater,
  dropdown,
  toggle,
  slider,
  currency,
} from '@formkit/pro'
import { generateClasses } from '@formkit/themes'
import { checkbox } from './formkit/inputs/checkbox'
import { radio } from './formkit/inputs/radio'
import { fileInput } from './formkit/inputs/file'
import { weekdayPercentageInput } from './formkit/inputs/week_percentage_input'
import { createRadioAltPlugin } from '~/formkit/plugins/radioAltPlugin'
import { addDescriptionPlugin } from '~/formkit/plugins/descriptionPlugin'
import { createHelpBoxPlugin } from '~/formkit/plugins/helpBoxPlugin'
import './assets/css/vendor-specific/formkit-button-icons.css'
import './assets/css/components/form-elements/stepper-nav.css'
import './assets/css/components/form-elements/help-box.css'
import './assets/css/components/form-elements/autocomplete.css'
import './assets/css/components/form-elements/slider.css'
import './assets/css/components/form-elements/dropdown.css'
import './assets/css/components/form-elements/toggle-switch.css'

const proPlugin = createProPlugin('fk-35db3f5cca', {
  autocomplete,
  repeater,
  dropdown,
  toggle,
  slider,
  currency,
})

const config = defaultConfig({
  plugins: [
    createMultiStepPlugin(),
    proPlugin,
    createRadioAltPlugin(),
    createHelpBoxPlugin(),
    addDescriptionPlugin,
  ],
  locales: { de },
  locale: 'de',
  icons: { trash },
  config: {
    classes: generateClasses({
      global: {
        help: 'hidden',
        legend: 'text-md font-medium lg:text-base text-gray-700',
        message: 'text-red-600',
        options: 'mt-10 mb-20',
        label: 'label',
      },
      autocomplete: {
        outer: 'autocomplete',
        wrapper: 'autocomplete-wrapper',
        inner: 'autocomplete-inner',
        input: 'autocomplete-input',
        listitem: 'autocomplete-list-item',
        listbox: 'autocomplete-listbox',
        listboxButton: 'autocomplete-listbox-button',
        dropdownWrapper: 'autocomplete-dropdown-wrapper',
      },
      dropdown: {
        outer: 'dropdown',
        wrapper: 'dropdown-wrapper',
        label: 'label',
        dropdownWrapper: '!static',
        inner: 'dropdown-inner',
        listitem: 'dropdown-list-item',
        option: 'dropdown-option',
        placeholder: 'placeholder',
        selector: 'dropdown-trigger',
        selectionsItem: 'float-left !visible',
        selectionsWrapper: 'max-h-[20px] overflow-hidden',
        truncationCount: 'hidden',
      },
      'family:text': {
        inner: 'flex flex-row',
        input: 'input w-full my-10',
      },
      checkbox: {
        wrapper: 'checkbox',
        label: 'p-0',
      },
      'family:multi-step': {
        tabs: 'stepper-nav',
        tab: 'step-tab',
        tabLabel: 'step-tab-label',
        badge: 'hidden',
      },
      step: {
        stepActions: 'py-20 grid grid-cols-[auto_1fr_auto]',
        stepNext:
          '[&_button]:button [&_button]:is-strong [&_button]:has-icon-arrow-east col-start-3',
        stepPrevious:
          '[&_button]:button [&_button]:has-icon-arrow-west col-start-1',
      },
      stepActions: {
        wrapper: 'container',
      },
      radio: {
        wrapper: 'radio',
        option: 'py-5',
        label: 'p-0 !font-normal',
      },
      select: {
        input: 'input w-full flex flex-row my-10 p-10',
      },
      textarea: {
        input: 'input',
      },
      toggle: {
        wrapper: 'grid grid-cols-[auto_1fr]',
        altLabel: 'col-span-2',
        inner: 'toggle-switch',
        input: 'toggle-switch-input',
        valueLabel: 'float-left ml-10',
      },
      steps: {
        input: 'step-button',
      },
      item: {
        addButton: '!pl-20',
      },
      repeater: {
        items: 'flex flex-col gap-20',
        item: 'fieldset',
        controlLabel: 'sr-only',
        controls: '',
        inner: 'pb-20',
        addButton: '[&_button]:button [&_button]:has-icon-add',
        removeIcon: '[&_svg]:w-[24px] [&_svg]:h-[24px]',
        remove: 'flex items-center',
        legend: 'pb-10',
      },
      slider: {
        track: 'w-full',
        trackWrapper: 'slider-track-wrapper',
        trackInner: 'slider-track',
        fill: 'slider-fill',
        handle: 'slider-handle',
        marks: 'slider-marks-container',
        mark: 'slider-mark',
      },
    }),
  },
})

// Overwriting existing components with custom config.
// @ts-ignore
config.inputs = {
  checkbox,
  radio,
  file: fileInput,
  weekdayPercentage: weekdayPercentageInput,
}

export default config
